'use strict';

var _ = require('lodash');
var FlightClassMixChartDataProviderService = function FlightClassMixChartDataProviderService(dataRetrieverService, searchCriteriaFilterBuilderService, ConfigurationService, classIndicesService, $q) {
  var emptyArray = [];
  function getData(screen, mode, type, metric, postDeparture) {
    var dataRetriever = dataRetrieverService.getDataRetriever(screen, mode);
    var legCabin = dataRetriever.getMetricDescriptor().params.legCabin;
    if (!legCabin) {
      return $q.when([]);
    }
    var allLegClasses = ConfigurationService.getClasses();
    var flightId = legCabin.flightId;
    var leg = legCabin.leg;
    var legCabinId = legCabin.legCabinId;
    var referenceCurveFlightId = legCabin.referenceCurveFlightId;
    var referenceCurveFlightIdString = referenceCurveFlightId ? referenceCurveFlightId : '';
    var allLegClassesIds = _.map(allLegClasses, function (legClassName) {
      return legCabinId + '.' + legClassName;
    });
    var rsql = 'flightId==' + flightId + ';curveIds==' + '(' + allLegClassesIds.join(',') + ')' + ';referenceCurveFlightId==' + referenceCurveFlightIdString;
    return dataRetriever.setCustomSearchCriteriaRules(rsql).retrieveComponentData(type, metric).then(function (data) {
      if (data === undefined) {
        return [];
      }
      var classesIndices = classIndicesService.prepareClassIndices(leg);
      return _.chain(data).filter(function (el) {
        return el.m1 !== undefined || el.m3 !== undefined || el.m4 !== undefined;
      }).sortBy(function (element) {
        return classesIndices[element.className];
      }).forEach(function (d) {
        d.tiles = emptyArray;
        d.circles = [];
        d.stackLabel = d.label;
        if (postDeparture) {
          if (d.m4 !== undefined) {
            d.circles.push({
              value: d.m4,
              css: 'm4-circle'
            });
          }
        } else {
          if (d.m3 !== undefined) {
            d.circles.push({
              value: d.m3,
              css: 'm3-circle'
            });
          }
          if (d.m4 !== undefined) {
            d.circles.push({
              value: d.m4,
              css: 'm4-circle'
            });
          }
        }
      }).value();
    });
  }
  return {
    getData: getData
  };
};
FlightClassMixChartDataProviderService.$inject = ['DataRetrieverService', 'FlightSearchCriteriaFilterBuilderService', 'ConfigurationService', 'ClassIndicesService', '$q'];
module.exports = FlightClassMixChartDataProviderService;